module.exports = __webpack_public_path__ + "img/server.0a8b62f9.png";